module.exports = __webpack_public_path__ + "static/media/paco-rabanne-one-million-big.26427226.png";